import { useQuery } from '@tanstack/react-query';
import { yearRangeOf } from '../lib/fromEngine';
import { DECLARATIONS_NEW_QUERY_KEYS, declarationsNewOverviewQuery } from './overviewQuery';

export { DECLARATIONS_NEW_QUERY_KEYS };

export const useDeclarationsOverview = (enabled = true) => {
	const query = useQuery({ ...declarationsNewOverviewQuery, enabled });
	return {
		overview: query.data,
		yearRange: yearRangeOf(query.data),
		isPending: query.isPending,
		isError: query.isError,
		refetch: query.refetch,
	};
};
